import { isBettoHistoryTenant } from "@pages/profile-v2/betto/shared/bettoHistoryStyles";
import styled from "styled-components";

const HistoryWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${isBettoHistoryTenant ? "16px" : "0"};
`;

const ItemWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: ${isBettoHistoryTenant ? "0" : "20px"};
	gap: ${isBettoHistoryTenant ? "12px" : "10px"};
	align-items: stretch;
`;

export { HistoryWrapper, ItemWrapper };
